import { useContext } from "react"
import AuthenticationContext from "./AuthenticationContext"

export default function useLogout() {
  const { logout } = useContext(AuthenticationContext)
  return logout
}
